import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Lock, Eye, Database, UserCheck, FileText, ArrowLeft } from 'lucide-react';

const Datenschutz = () => {
  return (
    <section className="section-padding bg-gradient-to-b from-luxury-pearl via-white to-luxury-pearl min-h-screen">
      <div className="container-custom max-w-4xl">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          {/* Back Button */}
          <motion.a
            href="/"
            whileHover={{ x: -5 }}
            className="inline-flex items-center text-luxury-gold hover:text-luxury-charcoal transition-colors mb-8 font-semibold"
          >
            <ArrowLeft className="mr-2" size={20} />
            Zurück zur Startseite
          </motion.a>

          {/* Header */}
          <div className="text-center mb-12">
            <Shield className="mx-auto mb-4 text-luxury-gold" size={64} />
            <h1 className="text-5xl md:text-6xl font-display font-bold text-luxury-charcoal mb-4">
              Datenschutzerklärung
            </h1>
            <div className="w-24 h-1 bg-luxury-gold mx-auto" />
          </div>

          {/* Content */}
          <div className="bg-white rounded-3xl shadow-2xl p-8 md:p-12 space-y-8">
            
            {/* Einleitung */}
            <div>
              <h2 className="text-2xl font-display font-bold text-luxury-charcoal mb-4 flex items-center">
                <Lock className="mr-3 text-luxury-gold" size={28} />
                Datenschutz
              </h2>
              <p className="text-luxury-slate leading-relaxed">
                Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.
              </p>
            </div>

            {/* Verantwortliche Stelle */}
            <div className="bg-luxury-gold/10 rounded-2xl p-6 border border-luxury-gold/30">
              <h3 className="text-xl font-display font-bold text-luxury-charcoal mb-4 flex items-center">
                <UserCheck className="mr-2 text-luxury-gold" size={24} />
                Verantwortliche Stelle
              </h3>
              <div className="space-y-2 text-luxury-slate">
                <p className="font-semibold">Nerma Lukic</p>
                <p>Hotel Haus Niggemann</p>
                <p>Wodental 4</p>
                <p>45529 Hattingen</p>
                <p className="pt-2">
                  <span className="font-semibold">Telefon:</span> 0 23 24 / 5 66 5
                </p>
                <p>
                  <span className="font-semibold">E-Mail:</span>{' '}
                  <a href="mailto:info@lacasa-hotel.de" className="text-luxury-gold hover:underline">
                    info@lacasa-hotel.de
                  </a>
                </p>
              </div>
            </div>

            {/* Erhebung und Speicherung */}
            <div>
              <h2 className="text-2xl font-display font-bold text-luxury-charcoal mb-4 flex items-center">
                <Database className="mr-3 text-luxury-gold" size={28} />
                Erhebung und Speicherung personenbezogener Daten
              </h2>
              <p className="text-luxury-slate leading-relaxed mb-4">
                Beim Besuch unserer Website werden durch den auf Ihrem Endgerät zum Einsatz kommenden Browser automatisch Informationen an den Server unserer Website gesendet. Diese Informationen werden temporär in einem sogenannten Logfile gespeichert.
              </p>
              <p className="text-luxury-slate leading-relaxed mb-4">
                Folgende Informationen werden dabei ohne Ihr Zutun erfasst und bis zur automatisierten Löschung gespeichert:
              </p>
              <ul className="list-disc list-inside space-y-2 text-luxury-slate ml-4">
                <li>IP-Adresse des anfragenden Rechners</li>
                <li>Datum und Uhrzeit des Zugriffs</li>
                <li>Name und URL der abgerufenen Datei</li>
                <li>Website, von der aus der Zugriff erfolgt (Referrer-URL)</li>
                <li>Verwendeter Browser und ggf. das Betriebssystem Ihres Rechners</li>
              </ul>
            </div>

            {/* Cookies */}
            <div>
              <h2 className="text-2xl font-display font-bold text-luxury-charcoal mb-4 flex items-center">
                <Eye className="mr-3 text-luxury-gold" size={28} />
                Cookies
              </h2>
              <p className="text-luxury-slate leading-relaxed mb-4">
                Unsere Website verwendet Cookies. Cookies sind kleine Textdateien, die auf Ihrem Endgerät gespeichert werden und die Ihr Browser speichert. Cookies richten auf Ihrem Endgerät keinen Schaden an und enthalten keine Viren.
              </p>
              <p className="text-luxury-slate leading-relaxed mb-4">
                Wir verwenden folgende Arten von Cookies:
              </p>
              <div className="space-y-4">
                <div className="bg-luxury-pearl rounded-xl p-4">
                  <h4 className="font-bold text-luxury-charcoal mb-2">Notwendige Cookies</h4>
                  <p className="text-luxury-slate text-sm">
                    Diese Cookies sind für den Betrieb der Website unbedingt erforderlich und ermöglichen grundlegende Funktionen wie die Navigation auf der Seite.
                  </p>
                </div>
                <div className="bg-luxury-pearl rounded-xl p-4">
                  <h4 className="font-bold text-luxury-charcoal mb-2">Funktionale Cookies</h4>
                  <p className="text-luxury-slate text-sm">
                    Diese Cookies ermöglichen es uns, Ihre Einstellungen zu speichern (z.B. Sprachauswahl) und Ihnen erweiterte, persönlichere Funktionen anzubieten.
                  </p>
                </div>
                <div className="bg-luxury-pearl rounded-xl p-4">
                  <h4 className="font-bold text-luxury-charcoal mb-2">Analyse Cookies</h4>
                  <p className="text-luxury-slate text-sm">
                    Diese Cookies helfen uns zu verstehen, wie Besucher mit unserer Website interagieren, indem Informationen anonym gesammelt und gemeldet werden.
                  </p>
                </div>
              </div>
            </div>

            {/* Kontaktformular */}
            <div>
              <h2 className="text-2xl font-display font-bold text-luxury-charcoal mb-4 flex items-center">
                <FileText className="mr-3 text-luxury-gold" size={28} />
                Kontaktformular und Buchungsanfragen
              </h2>
              <p className="text-luxury-slate leading-relaxed mb-4">
                Wenn Sie uns per Kontaktformular oder E-Mail Anfragen zukommen lassen, werden Ihre Angaben aus dem Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert.
              </p>
              <p className="text-luxury-slate leading-relaxed">
                Diese Daten geben wir nicht ohne Ihre Einwilligung weiter. Die Verarbeitung der in das Kontaktformular eingegebenen Daten erfolgt ausschließlich auf Grundlage Ihrer Einwilligung (Art. 6 Abs. 1 lit. a DSGVO).
              </p>
            </div>

            {/* Ihre Rechte */}
            <div className="bg-luxury-charcoal text-white rounded-2xl p-6">
              <h2 className="text-2xl font-display font-bold mb-4">
                Ihre Rechte
              </h2>
              <p className="text-luxury-cream leading-relaxed mb-4">
                Sie haben jederzeit das Recht auf:
              </p>
              <ul className="space-y-2 text-luxury-cream">
                <li className="flex items-start">
                  <span className="text-luxury-gold mr-2">•</span>
                  <span>Auskunft über Ihre bei uns gespeicherten Daten</span>
                </li>
                <li className="flex items-start">
                  <span className="text-luxury-gold mr-2">•</span>
                  <span>Berichtigung unrichtiger personenbezogener Daten</span>
                </li>
                <li className="flex items-start">
                  <span className="text-luxury-gold mr-2">•</span>
                  <span>Löschung Ihrer bei uns gespeicherten Daten</span>
                </li>
                <li className="flex items-start">
                  <span className="text-luxury-gold mr-2">•</span>
                  <span>Einschränkung der Datenverarbeitung</span>
                </li>
                <li className="flex items-start">
                  <span className="text-luxury-gold mr-2">•</span>
                  <span>Datenübertragbarkeit</span>
                </li>
                <li className="flex items-start">
                  <span className="text-luxury-gold mr-2">•</span>
                  <span>Widerspruch gegen die Verarbeitung Ihrer Daten</span>
                </li>
                <li className="flex items-start">
                  <span className="text-luxury-gold mr-2">•</span>
                  <span>Beschwerde bei einer Aufsichtsbehörde</span>
                </li>
              </ul>
            </div>

            {/* SSL Verschlüsselung */}
            <div>
              <h2 className="text-2xl font-display font-bold text-luxury-charcoal mb-4">
                SSL-Verschlüsselung
              </h2>
              <p className="text-luxury-slate leading-relaxed">
                Diese Seite nutzt aus Gründen der Sicherheit und zum Schutz der Übertragung vertraulicher Inhalte eine SSL-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie daran, dass die Adresszeile des Browsers von "http://" auf "https://" wechselt und an dem Schloss-Symbol in Ihrer Browserzeile.
              </p>
            </div>

            {/* Aktualität */}
            <div className="border-t border-luxury-gold/30 pt-6">
              <p className="text-sm text-luxury-slate italic">
                Stand dieser Datenschutzerklärung: Dezember 2025
              </p>
            </div>

          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Datenschutz;
